module.exports = __webpack_public_path__ + "img/head-banner.a24dd2c5.jpeg";